import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { ChapterEnum } from 'gql/graphql';

import { useCallback, useMemo } from 'react';

import {
    uerWorkOrderPriceListUerCodeFilterGql,
    uerWorkOrderPriceListUerNameFilterGql,
    uerWorkOrderPriceListUerSectionFilterGql,
    uerWorkOrderPriceListUerSubSectionFilterGql,
} from '../workOrderPriceListUerQueries';

interface IUseUerWorkOrderPriceListUerFilters {
    changeFilterHandler: (params: { fieldName: string; checkedValues: string[] }) => void;
    workOrderObjectId: number;
    chapter: ChapterEnum;
}

export const useUerWorkOrderPriceListUerFilters = (props: IUseUerWorkOrderPriceListUerFilters) => {
    const { changeFilterHandler, workOrderObjectId, chapter } = props;

    const variables = useMemo<{ workOrderObjectId: any; chapter: ChapterEnum }>(
        () => ({
            chapter,
            workOrderObjectId,
        }),
        [chapter, workOrderObjectId],
    );

    const getFilterParams = useCallback(
        (value: string) => ({
            value: {
                containsi: value,
            },
        }),
        [],
    );

    return useMemo(
        () => [
            {
                field: 'sectionName',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: uerWorkOrderPriceListUerSectionFilterGql,
                    customWhereVariablesGetter: getFilterParams,
                    dataAccessor: 'uerWorkOrderPriceListUerSectionFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['code'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'groupName',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: uerWorkOrderPriceListUerSubSectionFilterGql,
                    customWhereVariablesGetter: getFilterParams,
                    dataAccessor: 'uerWorkOrderPriceListUerSubSectionFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['code'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Подраздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'code',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: uerWorkOrderPriceListUerCodeFilterGql,
                    customWhereVariablesGetter: getFilterParams,
                    dataAccessor: 'uerWorkOrderPriceListUerCodeFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['code'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Шифр',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'name',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: uerWorkOrderPriceListUerNameFilterGql,
                    customWhereVariablesGetter: getFilterParams,
                    dataAccessor: 'uerWorkOrderPriceListUerNameFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['name'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Наименование',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
        ],
        [changeFilterHandler, getFilterParams, variables],
    );
};
